{
  "name": "mytempton-kundeportal",
  "version": "2.307.1",
  "license": "",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --watch=true --open=true",
    "build": "ng build",
    "lint": "ng lint",
    "build-preprod": "node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng serve --configuration=preprod"
  },
  "private": true,
  "overrides": {
    "pdfmake-wrapper": {
      "pdfmake": "$pdfmake"
    },
    "exceljs": {
      "uuid": "^11.1.1"
    }
  },
  "dependencies": {
    "@angular/animations": "^22.1.1",
    "@angular/cdk": "^22.1.2",
    "@angular/common": "^22.1.1",
    "@angular/compiler": "^22.1.1",
    "@angular/core": "^22.1.1",
    "@angular/forms": "^22.1.1",
    "@angular/localize": "^22.1.1",
    "@angular/material": "^22.1.2",
    "@angular/material-moment-adapter": "^22.1.2",
    "@angular/platform-browser": "^22.1.1",
    "@angular/platform-browser-dynamic": "^22.1.1",
    "@angular/router": "^22.1.1",
    "@azure/msal-browser": "3.25.x",
    "@tempton/ngx-msal": "github:tempton-gmbh/ngx-msal.npm#v0.3.4",
    "@types/crypto-js": "^4.2.2",
    "crypto-js": "^4.2.0",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "hammerjs": "^2.0.8",
    "moment": "^2.30.1",
    "ngx-http-env": "^0.2.0",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-pagination": "^6.0.3",
    "pdfmake": "^0.3.11",
    "pdfmake-wrapper": "^2.1.3",
    "reflect-metadata": "^0.2.2",
    "rxjs": "^7.8.2",
    "swiper": "^14.0.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.1.3",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.1",
    "@types/hammerjs": "^2.0.46",
    "@types/node": "^22.20.0",
    "sass": "^1.101.0",
    "ts-node": "~10.9.2",
    "typescript": "~6.0.3"
  }
}
